// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import LabeledCriteria from '../../../shared/components/labeled-criteria';
import ReportCriteriaFooter from '../../shared/components/report-criteria-footer';

const LaborRateHistoryReportCriteria = props =>
    <div className='labor-rate-history-criteria'>
        <div className='history-to-display-criteria'>
            <LabeledCriteria
                className='history-to-display-criteria'
                isRequired={true}
                label='HISTORY_TO_DISPLAY'
                max='9999'
                min='1'
                onInputChange={props.onHistoryToDisplayChange}
                placeholder='ENTER_A_NUMBER_BETWEEN_0_AND_10000'
                type='number'
                value={props.historyToDisplay}
            />
        </div>
        <ReportCriteriaFooter
            canExport={props.canExport}
            canRunReport={props.canRunReport}
            isRequired={true}
            onCriteriaReset={props.onCriteriaReset}
            onDownloadToExcel={props.onExportToCsv}
            onRunReport={props.onCreateLaborRateHistoryReport}
            showExport={true}
            showReport={true}
        />
    </div>;

LaborRateHistoryReportCriteria.displayName = 'LaborRateHistoryReportCriteria';
LaborRateHistoryReportCriteria.propTypes = {
    canExport: PropTypes.bool.isRequired,
    canRunReport: PropTypes.bool.isRequired,
    historyToDisplay: PropTypes.number,
    onCreateLaborRateHistoryReport: PropTypes.func.isRequired,
    onCriteriaReset: PropTypes.func.isRequired,
    onExportToCsv: PropTypes.func.isRequired,
    onHistoryToDisplayChange: PropTypes.func.isRequired
};

export default LaborRateHistoryReportCriteria;



// WEBPACK FOOTER //
// ./src/reports/labor-rate-history/components/labor-rate-history-report-criteria.js